import type { FC } from 'react';
import { Link } from 'gatsby';
import type { HomeLatestBlogs } from '../../../@types/gql/home';
import OpacitySlideIn from '../../animation/opacity-slide-in';
import Swiper from '../../shared/swiper';
import BlogCard from './card';

const HomeBlogsSection: FC<HomeLatestBlogs> = ({ nodes }) => {
  return (
    <section className="py-14" style={{ backgroundColor: '#f7f7f7' }}>
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-1 gap-10 relative">
          <OpacitySlideIn className="flex" slideFrom={{ x: 0, y: 20 }}>
            <h4 className="text-4xl font-bold max-w-xl leading-tight mt-6 flex-1 whitespace-pre-wrap max-lg:text-2xl max-md:mt-0">
              Latest news from our blog
            </h4>
            <Link
              className="py-2 px-3 bottom-0 flex h-11 absolute right-0 space-x-1 font-bold text-base items-center transition-smooth rounded-md w-fit border border-red-600 text-red-600 max-lg:text-sm max-md:relative"
              to="/blogs/"
              type="button"
            >
              VIEW ALL
            </Link>
          </OpacitySlideIn>
        </div>
        <div className="">
          <Swiper className="gap-4 pt-10 lg:grid lg:grid-cols-2 flex-none" hideControls>
            {nodes?.map((each, idx) => {
              return (
                <OpacitySlideIn
                  delay={idx * 0.05 + 0.1}
                  key={each.Slug}
                  slideFrom={{ x: 0, y: 20 }}
                  className='flex-col'
                >
                 
                  <BlogCard {...each} />
                
                </OpacitySlideIn>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default HomeBlogsSection;
